import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes = [
  // 首页
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  // 客服端
  {
    path: "/service",
    name: "service",
    component: () => import("../views/serviceView.vue"),

    children: [
      //控制面板
      {
        path: "service",
        component: () => import("../views/serviceView.vue"),
      },
      //控制面板
      {
        path: "",
        component: () => import("../components/Service/ControlView1.vue"),
      },
      {
        path: "callData",
        component: () => import("../components/Service/CallData.vue"),
      },
      //客户管理列表
      {
        path: "clues",
        component: () => import("../components/Service/CluesView.vue"),
      },
      // 销售客户公海
      {
        path: "sea",
        component: () => import("../components/Service/SeaView.vue"),
      },
       // 大金额线索公海池
      {
        path: "majorClientSeaView",
        component: () => import("../components/Service/MajorClientSeaView.vue"),
      },
      // 销售客户公海 -- 新建用户
      {
        path: "new",
        component: () => import("../components/Service/SeaNewView.vue"),
      },
      // 我的台账
      {
        path: "pendingOrders",
        component: () => import("../components/Service/pendingOrders.vue"),
      },
      // 我的台账
      {
        path: "stayCollection",
        component: () => import("../components/Service/stayCollectionView.vue"),
      },
      // 跟进信息
      {
        path: "flowupInfo",
        component: () =>
          import("../components/Service/FolowupInfomation/tabletitle.vue"),
      },
      // 未触达
      {
        path: "notReached",
        component: () => import("../components/Service/NotReached/index.vue"),
      },
      // 转调解-主管审核
      {
        path: "check",
        component: () => import("../components/Service/CheckView.vue"),
      },
            // 暂停服务-主管审核
      {
        path: "check_stop",
        component: () => import("../components/Service/CheckViewStop.vue"),
      },
            // 暂停服务-主管详情
      {
        path: "checkdetailStop",
        component: () =>
          import("../components/CheckElementStop/CheckDetailView.vue"),
      },
      // 恢复服务-主管审核
      {
        path: "check_resume",
        component: () => import("../components/Service/CheckViewResume.vue"),
      },
      // 恢复恢复-主管详情
      {
        path: "checkdetailResume",
        component: () =>
          import("../components/CheckElementResume/CheckDetailView.vue"),
      },
      // 暂停服务-商户主审核  
      {
        path: "check_stop_merchant",
        component: () => import("../components/Service/CheckViewStopMerchant.vue"),
      },
      //暂停服务- 商户主详情
      {
        path: "checkdetailStopMerchant",
        component: () =>
          import("../components/CheckElementStopMerchant/CheckDetailView.vue"),
      },
      // 恢复服务-商户主审核 
      {
        path: "check_resume_merchant",
        component: () => import("../components/Service/CheckViewResumeMerchant.vue"),
      },
      // 恢复服务-商户主详情
      {
        path: "checkdetailResumeMerchant",
        component: () =>
          import("../components/CheckElementResumeMerchant/CheckDetailView.vue"),
      },

      // 转调解-商户主审核
      {
        path: "merchantCheck",
        component: () => import("../components/Service/MerchantCheckView.vue"),
      },
      // 转律助-主管审核
      {
        path: "mediationCheck",
        component: () => import("../components/Service/MediationCheckView.vue"),
      },
      // 转律助-商户主审核
      {
        path: "mainMediationCheck",
        component: () => import("../components/Service/MainMediationCheckView.vue"),
      },
      // 合同作废-主管审核
      {
        path: "cancelCheck",
        component: () => import("../components/Service/CancelCheckView.vue"),
      },
      // 合同作废-商户主审核
      {
        path: "mainCancelCheck",
        component: () => import("../components/Service/MainCancelCheckView.vue"),
      },
      // 转解决方案专家-主管审核
      {
        path: "expertCheck",
        component: () => import("../components/Service/ExpertCheckView.vue"),
      },
      // 转解决方案专家-商户主审核
      {
        path: "mainExpertCheck",
        component: () => import("../components/Service/MainExpertCheckView.vue"),
      },
      // 预调解-审核
      {
        path: "premediationaudit",
        component: () => import("../components/Service/premediationaudit.vue"),
      },
      // 客情证据审核
      {
        path: "evidenceReview",
        component: () => import("../components/Service/EvidenceReview.vue"),
      },
      // 审核详情
      {
        path: "checkdetail",
        component: () =>
          import("../components/CheckElement/CheckDetailView.vue"),
      },
      // 客户详情
      {
        path: "management",
        name: "management",
        component: () =>
          import("../components/ManagementElement/ManagementView.vue"),
      },
      // 案件信息
      {
        path: "casedetail",
        name: "casedetail",
        component: () =>
          import("../components/RoundElement/CaseDatailView.vue"),
      },
      // 备注跟进
      {
        path: "remarksFollow",
        name: "remarksFollow",
        component: () => import("../components/Service/remarksFollow.vue"),
      },
      // 案件管理
      {
        path: "case",
        component: () => import("../components/Service/CaseView.vue"),
      },

      // 播报设置-播报目标填报
      {
        path: "target",
        component: () => import("../components/BroadcastElement/Target.vue"),
      },
      // 播报设置-播报口号设置
      {
        path: "slogan",
        component: () => import("../components/BroadcastElement/Slogan.vue"),
      },
      // 播报设置-团队人力填报
      {
        path: "manpower",
        component: () => import("../components/BroadcastElement/Manpower.vue"),
      },
      {
        path: "hdvue",
        component: () => import("../components/HDvue.vue"),
      },
      // 短信管理 === 发送记录
      {
        path: "sendMessage",
        component: () =>
          import("../components/MessageElement/SendMessageView.vue"),
      },
      // 短信管理 === 新建发送
      {
        path: "creatMessage",
        component: () =>
          import("../components/MessageElement/CreatMessageView.vue"),
      }, // 短信记录详情
      {
        path: "msgDetail",
        name: "msgDetail",
        component: () =>
          import("../components/MessageElement/components/msgDetailView.vue"),
      },
      // 菜单管理
      {
        path: "menu_list",
        name: "menu_list",
        component: () => import("../components/Permission/menu/index.vue"),
      },
      // 角色管理
      {
        path: "role_list",
        name: "role_list",
        component: () => import("../components/Permission/role/index.vue"),
      },
      //组织结构管理
      {
        path: "org_list",
        name: "org_list",
        component: () => import("../components/Permission/org/index.vue"),
      },
      //用户管理
      {
        path: "user_list",
        name: "user_list",
        component: () => import("../components/Permission/user/index.vue"),
      },
      //分组管理
      {
        path: "group_list",
        name: "group_list",
        component: () => import("../components/Permission/group/index.vue"),
      },
      //模式管理
      {
        path: "buinessmode_list",
        name: "buinessmode_list",
        component: () => import("../components/Permission/buinessmode/index.vue"),
      },
      // 系统设置
      // 欠款平台
      {
        path: "bank_platform_list",
        name: "bank_platform_list",
        component: () => import("../components/Config/bankPlatform/index.vue"),
      },
      // 一级跟进动作
      {
        path: "follow_action_list",
        name: "follow_action_list",
        component: () => import("../components/Config/followAction/index.vue"),
      },
      // 标签管理
      {
        path: "tag_manage_list",
        name: "tag_manage_list",
        component: () => import("../components/Config/tagManage/index.vue"),
      },
      // 线索来源
      {
        path: "thread_source_list",
        name: "thread_source_list",
        component: () => import("../components/Config/threadSource/index.vue"),
      },
      // 流失原因
      {
        path: "scenarion_info_list",
        name: "scenarion_info_list",
        component: () =>
          import("../components/Config/threadScenarionInfo/index.vue"),
      },
      // 用户资料
      {
        path: "custom_field_list",
        name: "custom_field_list",
        component: () =>
          import("../components/Config/threadCustomField/index.vue"),
      },
      // 短信模板分类
      {
        path: "sms_temp_cate_list",
        name: "sms_temp_cate_list",
        component: () =>
          import("../components/Config/smsTempCategory/index.vue"),
      },
      // 短信模板
      {
        path: "sms_temp_list",
        name: "sms_temp_list",
        component: () => import("../components/Config/smsTemp/index.vue"),
      },
      // 播报机器人
      {
        path: "robot",
        name: "robot",
        component: () => import("../components/BroadcastElement/robot.vue"),
      },
       // 群预警
      {
        path: "groupWarning",
        name: "groupWarning",
        component: () => import("../components/Config/groupWarning/index.vue"),
      },
      // 脱敏警告
      {
        path: "desensitize",
        name: "desensitize",
        component: () =>
          import("../components/Desensitize/customer_desensitize_list.vue"),
      },
      // 登录日志
      {
        path: "login_log_list",
        name: "login_log_list",
        component: () => import("../components/Desensitize/login_log_list.vue"),
      },
      // 擂台赛事
      {
        path: "event",
        name: "event",
        component: () => import("../components/Event/index.vue"),
      },
      // 赛事列表
      {
        path: "eventList",
        name: "eventList",
        component: () => import("../components/Event/eventList.vue"),
      },
      {
        path: "lotteryActivity",
        name: "lotteryActivity",
        component: () =>
          import("../components/Config/lotteryActivity/index.vue"),
      },
            {
        path: "discountTool",
        name: "discountTool",
        component: () =>
          import("../components/Config/discountTool/index.vue"),
      },
      // 数据调整-补录订单
      {
        path: "supplementaryOrder",
        name: "supplementaryOrder",
        component: () => import("../components/AdjustData/supplementaryOrder.vue"),
      },
      // 数据调整-补录订单校验
      {
        path: "verifyOrder",
        name: "verifyOrder",
        component: () => import("../components/AdjustData/verifyOrder.vue"),
      },
    ],
  },
  {
    path: "/404",
    name: "/404",
    component: () => import("../views/NotFound.vue"),
  },
  {
    path: "/:pathMatch(.*)",
    redirect: "/404",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
